import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faBuilding, faFolderOpen, faUsers, faTriangleExclamation,
  faFileText, faClipboardCheck, faListCheck, faWandMagicSparkles,
} from "@fortawesome/free-solid-svg-icons";
import { createModuleExtensionHost } from "../../modules/extensions/createModuleExtensionHost";

export default createModuleExtensionHost({
  moduleKey: "realestate",
  scriptUrl: "/realestate/extensions/index.js",
  styleUrl: "/realestate/extensions/index.css",
  sdk: {
    icons: {
      faBuilding, faFolderOpen, faUsers, faTriangleExclamation,
      faFileText, faClipboardCheck, faListCheck, faWandMagicSparkles,
    },
    fontawesome: { FontAwesomeIcon },
  },
});
